import { render, staticRenderFns } from "./BannerNotifications.vue?vue&type=template&id=3c4b36dc&scoped=true&"
import script from "./BannerNotifications.vue?vue&type=script&lang=ts&"
export * from "./BannerNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./BannerNotifications.vue?vue&type=style&index=0&id=3c4b36dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b36dc",
  null
  
)

export default component.exports